import './SelectableBubbles.scss';

export interface BubbleOption {
  value: string;
  label: string;
  description?: string;
  disabled?: boolean;
}

interface SelectableBubblesProps {
  options: BubbleOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  multiple?: boolean;
  compact?: boolean;
}

export function SelectableBubbles({
  options,
  selected,
  onChange,
  multiple = true,
  compact = false
}: SelectableBubblesProps) {
  const handleClick = (value: string, disabled?: boolean) => {
    if (disabled) return;

    if (multiple) {
      if (selected.includes(value)) {
        onChange(selected.filter(v => v !== value));
      } else {
        onChange([...selected, value]);
      }
    } else {
      if (selected.includes(value)) {
        onChange([]);
      } else {
        onChange([value]);
      }
    }
  };

  return (
    <div className={`selectable-bubbles ${compact ? 'compact' : ''}`}>
      {options.map(option => {
        const isSelected = selected.includes(option.value);
        const classNames = [
          'selectable-bubble',
          isSelected ? 'selected' : '',
          option.disabled ? 'disabled' : '',
          compact ? 'compact' : ''
        ].filter(Boolean).join(' ');

        return (
          <div
            key={option.value}
            className={classNames}
            onClick={() => handleClick(option.value, option.disabled)}
            data-tooltip-id={option.disabled ? 'main-tooltip' : undefined}
            data-tooltip-content={option.disabled ? 'Coming soon' : undefined}
          >
            <span className="bubble-label">{option.label}</span>
            {option.description && !compact && (
              <span className="bubble-description">{option.description}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
